import { Layout } from 'antd';
import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';
import FooterComponent from '../components/Footer/Footer';
import Banner from '../components/Banner/Banner';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPendingSlaInvitation, getPendingNdaInvitation } from '../redux/slices/EsignSlice';
import "./Layout.scss";

const { Content, Footer } = Layout;

const DashboardLayout = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        if (user?.orgId) {
            dispatch(getPendingSlaInvitation());
            dispatch(getPendingNdaInvitation());
        }
    }, [dispatch, user?.orgId]);

    return (
        <Layout className='layout'>
            <Sidebar />
            <Layout>
                <Navbar />
                <Banner />
                <Content className='dashboard-content'>
                    <Outlet />
                </Content>
                <Footer className='footer'>
                    <FooterComponent />
                </Footer>
            </Layout>
        </Layout>
    );
};

export default DashboardLayout;
